module.exports = __webpack_public_path__ + "img/pyramidFlag.ba783da1.png";